(function (module) {
    'use strict';

    function HelpConfig($stateProvider, $translatePartialLoaderProvider) {
        // Route

        $stateProvider.state('root.help', {
            url: '/help',
            data: {
                pageTitle: 'Help',
            },

            views: {
                'content@root': {
                    templateUrl: '/js/help/help.html',
                    controller: 'HelpCtrl as $ctrl',
                },
            },
            bodyClass: 'page--help',
        });

        // Translations
        $translatePartialLoaderProvider.addPart('/js/help');
    }

    function HelpCtrl($stateParams, $state) {
        this.$onInit = () => {};
    }

    module.config(HelpConfig).controller('HelpCtrl', HelpCtrl);
})(angular.module('rocket.components'));
